import type { ReactNode } from 'react'
import { MARKETING_SECTION_TITLE_ON_DARK } from '@/components/marketing/marketing-typography'
import { cn } from '@/lib/utils'

type MarketingWaitlistBandProps = {
  title: string
  lead?: string
  children: ReactNode
  className?: string
}

export function MarketingWaitlistBand({ title, lead, children, className }: MarketingWaitlistBandProps) {
  return (
    <div
      className={cn(
        'rounded-[42px] bg-[var(--marketing-band-bg,#1f2528)] px-9 py-[72px] text-center text-white',
        'bg-[radial-gradient(circle_at_50%_0%,rgba(246,201,76,0.30),transparent_42%)]',
        className
      )}
    >
      <h2 className={cn('mx-auto mb-[18px] max-w-[800px]', MARKETING_SECTION_TITLE_ON_DARK)}>
        {title}
      </h2>
      {lead ? (
        <p className="mx-auto mb-0 max-w-[760px] text-lg leading-relaxed text-white/70">{lead}</p>
      ) : null}
      {children}
    </div>
  )
}
